import {useAuth0} from "@auth0/auth0-react"
import React from "react"

import {Button} from "@/components/ui/button"

interface LoginProps {}

const Login: React.FC<LoginProps> = () => {
    const {loginWithRedirect} = useAuth0()

    return (
        <div className="flex h-screen flex-col">
            <div className="container mx-auto flex flex-1 items-center justify-center">
                <div className="w-full max-w-md space-y-6 rounded-lg bg-secondary p-8 text-center text-secondary-foreground shadow-lg">
                    <h1 className="text-3xl font-bold text-gray-700">Adviser Chatbot</h1>
                    <p className="text-gray-500">Please log in with your @futurenet.com account to continue</p>
                    <Button onClick={() => loginWithRedirect()} className="w-full bg-primary py-3 font-semibold">
                        Log In
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Login
